import React from 'react';
import classNames from 'classnames';

function startButtonText(type) {
  return type.toLowerCase() === 'lesson'
    ? t('paths.dashboard.start_lesson')
    : t('paths.dashboard.start_other');
}

function getLabel(status, type) {
  const labels = {
    inProgress: () => t('paths.dashboard.continue_working'),
    available: () => startButtonText(type),
    completed: () => t('paths.dashboard.view'),
    awaitingGrade: () => t('paths.dashboard.view'),
  };
  return labels[status]?.call() || null;
}

const ActionButton = ({ status, type, urls, small, className }) => {
  const getClassName = classNames('PathContentButton', {
    [className]: !!className,
    'PathContentButton--small': small,
    'CustomColor--backgroundColor': status === 'available',
  });

  const label = getLabel(status, type);

  return label !== null ? (
    <a href={urls.view} className={getClassName}>
      {getLabel(status, type)}
    </a>
  ) : null;
};

export default ActionButton;
